// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { MessageProcessorBase } from "./MessageProcessorBase.ts"
import { PFixXmlMessage } from "../Messages/PFixXmlMessage.js"
export let XMLMessageProcessor = function ()
{
    MessageProcessorBase.call(this)
}

XMLMessageProcessor.prototype = Object.create(XMLMessageProcessor.prototype)

XMLMessageProcessor.prototype.decode = function (fieldSet)
{
    // TODO. Ugly. Refactor.
    // Hack for using "Request id + Promise" feature in ProcessorWorker.js.
    return [new PFixXmlMessage(fieldSet)]
}
